import React from "react";

const SkeletonNftWithTimer = () => {
  return (
    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
      <div className="skeleton snwt__skeleton"></div>
    </div>
  );
};

export default SkeletonNftWithTimer;
